import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useModuleContext from "../../hooks/useModuleContext";

// Components
import Veterinary from "../veterinary";

// Styles
import { Tabs } from "antd";
import { Container } from "./styles";
import Unit from "../unit";
import GroupItem from "../groupItem";
import ItemsGroup from "../itemsGroup";

const SupplementParameters = () => {
  const {
    translation,
    groupSelected: { id: groupId },
    farmSelected: { id: farmId },
  } = useSelector((state) => state.app);
  const { isAllowedFunctions } = useModuleContext();
  const [tabSelect, setTablSelect] = useState("1");

  useEffect(() => {
    setTablSelect(isAllowedFunctions(["SUPPLEMENTS"]) ? "1" : "2");
  }, [isAllowedFunctions, groupId, farmId]);

  return (
    <Container>
      <Tabs
        type="card"
        defaultActiveKey="1"
        activeKey={tabSelect}
        onChange={(key) => setTablSelect(key)}
      >
        <Tabs.TabPane
          tab={<span>{translation.parameters.tabs.stock}</span>}
          key="1"
        >
          <Tabs type="card" defaultActiveKey="1-1">
            <Tabs.TabPane
              tab={<span>{translation.parameters.tabs.unit}</span>}
              key="1-1"
            >
              <Unit />
            </Tabs.TabPane>
            <Tabs.TabPane
              tab={<span>{translation.groupItem.title}</span>}
              key="1-2"
            >
              <GroupItem />
            </Tabs.TabPane>
            <Tabs.TabPane
              tab={<span>{translation.itemsGroup.title}</span>}
              key="1-3"
            >
              <ItemsGroup />
            </Tabs.TabPane>
          </Tabs>
        </Tabs.TabPane>
        <Tabs.TabPane
          tab={<span>{translation.parameters.tabs.veterinary}</span>}
          key="2"
          disabled={!isAllowedFunctions(["VETERINARY"])}
        >
          <Veterinary />
        </Tabs.TabPane>
      </Tabs>
    </Container>
  );
};

export default SupplementParameters;
